/** @jsxImportSource @emotion/react */

import { CSSObject } from '@emotion/react';
import useTheme, { IColors } from '../hooks/useTheme';
import { images } from '../constants/assets';
import useLanguage from '../hooks/useLanguage';
import { colorFilter } from '../utils/colorFilter';

interface ILocalImage {
  src: keyof typeof images;
  alt?: string;
  tint?: keyof typeof IColors;
  css?: CSSObject;
}

const LocalImage = ({ src, tint, alt, ...props }: ILocalImage) => {
  const { color } = useTheme();
  const language = useLanguage();

  const getAltLabel = () => {
    if (alt !== undefined) {
      return alt;
    }

    return language.get(src.toLowerCase());
  };

  const STYLE: CSSObject = {
    ...(tint && {
      filter: colorFilter(color[tint]),
    }),
  };

  const { css: cssProp, ...restProps } = props as typeof props & {
    css?: CSSObject;
  };
  return (
    <img
      src={images[src]}
      alt={getAltLabel()}
      css={[STYLE, cssProp]}
      {...restProps}
    />
  );
};

export default LocalImage;
